import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import LocationTypeLayer from "../components/LocationTypeLayer";

const LocationTypePage = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Role Access" />

        {/* RoleAccessLayer */}
        <LocationTypeLayer />

      </MasterLayout>

    </>
  );
};

export default LocationTypePage; 
